// =============================================================================
// hatGeometry — shared measurements of jesterhat.svg, used by both the static
// JesterHat overlay and the head-TRACKED hat on video tiles, so they agree on
// where the "band" (the hat's opening, the part that hugs the head) sits.
//
// All fractions measured from the committed jesterhat.svg (see the tuning spike
// archive/experiments/jesterhat-headtracking for the derivation).
// =============================================================================

// Art aspect ratio (width / height).
export const HAT_ASPECT = 565.59442 / 448.49576; // ≈ 1.261

// The GOLD BAND (opening) within the SVG box, as fractions of the box:
//   wFrac  = band width  = 39.3% of the box width (box is ~2.5× wider than band)
//   cxFrac = band center X = 48.7% across
//   cyFrac = band center Y = 81.2% down
export const BAND = { wFrac: 0.393, cxFrac: 0.487, cyFrac: 0.812 };

// The art is drawn slightly crooked — the band's opening runs ~-6.8° in the file
// (right corner higher). Pre-rotate the image by +ART_TILT_DEG to level the band
// before adding any head roll.
export const ART_TILT_DEG = 6.8;
